<template>
  <div class="user-detail">
	  <div class="detail-header-part">
			<p>シッター情報</p>
		</div>
		<div class="detail-top-part">
			<p class="left">
				<img v-bind:src="user | avatar500" @click="modalOpen"/>
				<b-button ref="modal_btn" v-b-modal.modal-scrollable class="dis-none"></b-button>
			</p>
			<div class="right">
				<b-table-simple stacked>
					<b-tbody>
						<b-tr>
							<b-td stacked-heading="名前" v-if="!!user.name">{{ user.name }}</b-td>
							<b-td stacked-heading="年齢" v-if="!!user.age">{{ user.age }}</b-td>
							<b-td stacked-heading="ID" v-if="!!user.email">{{ user.email }}</b-td>
							<b-td stacked-heading="電話番号" v-if="!!user.phone">{{ user.phone }}</b-td>
							<b-td stacked-heading="自宅住所" v-if="!!user.sitter && !!user.sitter.address">{{ user.sitter.address || '' }}</b-td>
							<b-td stacked-heading="勤務先住所" v-if="!!user.sitter && !!user.sitter.working_adrs">{{ user.sitter.working_adrs }}</b-td>
							<b-td stacked-heading="要約文" v-if="!!user.sitter && !!user.sitter.summary">{{ user.sitter.summary }}</b-td>
							<b-td stacked-heading="登録日">{{ user.created_at | formatDateTime }}</b-td>
							<b-td stacked-heading="最終ログイン">{{ user.last_login_at | formatDateTime }}</b-td>
							<b-td stacked-heading="ログイン回数">{{ user.login_count }}</b-td>
							<b-td stacked-heading="自己紹介" v-if="!!user.sitter && !!user.sitter.description">{{ user.sitter.description }}</b-td>
							<b-td stacked-heading="保育可能年齢" v-if="!!user.sitter && !!user.sitter.cc_age_from">{{ user.sitter | ccAge }}</b-td>
							<b-td stacked-heading="受け入れ可能人数" v-if="!!user.sitter && !!user.sitter.child_cnt">{{ user.sitter | childCnt }}</b-td>
							<b-td stacked-heading="子育て経験" v-if="!!user.sitter && !!user.sitter.sitter_exp">{{ user.sitter.sitter_exp }}年</b-td>
							<b-td stacked-heading="シッター経験" v-if="!!user.sitter && !!user.sitter.parent_exp">{{ user.sitter.parent_exp }}年</b-td>
							<b-td stacked-heading="最低サポート期間" v-if="!!user.sitter && !!user.sitter.min_hours">{{ user.sitter.min_hours }}時間以上</b-td>
							<b-td stacked-heading="資格" v-if="!!user.sitter && !!user.sitter.categories && user.sitter.categories.length > 0">{{ user.sitter | categories }}</b-td>
						</b-tr>
					</b-tbody>
				</b-table-simple>
			</div>
			<div class="control-bar">
				<div class="btn-group">
					<b-button @click="user.admin_blocked == 0 ? hide() : show()">{{ user.admin_blocked == 0 ? '非表示' : '表示'}}</b-button>
					<b-button @click="remove" class="red">消去</b-button>
				</div>
				<div class="option-info" v-if="!!user.sitter && !!user.sitter.sitter_options && user.sitter.sitter_options.length > 0">
					<h4>オプション</h4>
					<div v-for="(sitterOption, index) in user.sitter.sitter_options"
					:key="index" class="option-item">
						<p class="option-avatar">
							<img v-bind:src="`/images/icon_option${sitterOption.option.id}.png`"/>
						</p>
						<div class="option-cont">
							<h5>{{ sitterOption.option.name }}</h5>
							<p>{{ sitterOption.description }}</p>
							<p>+¥{{ sitterOption.price | formatNumber }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<b-modal id="modal-scrollable" class="avatar-modal" ok-title="確認" cancel-title="キャンセル">
			<div>
				<img v-bind:src="user | originalPhoto"/>
			</div>
		</b-modal>
  </div>
</template>
<script>
import apiClient from '../../backend'
export default {
  methods: {
		modalOpen() {
			this.$refs.modal_btn.click()
		},
		hide() {
			apiClient.updateUser({ 
				user_id: this.$route.params.id,
				admin_blocked: 1
			}).then(response => {
				this.$router.go(-1)
			})
		},
		show() {
			apiClient.updateUser({ 
				user_id: this.$route.params.id,
				admin_blocked: 0
			}).then(response => {
				this.$router.go(-1)
			})
		},
		remove() {
			apiClient.deleteUser({ 
				id: this.$route.params.id 
			}).then(response => {
				this.$router.go(-1)
			})
		}
  },
  data () {
    return {
			user: {
				sitter: {}
			}
    }
  },
  components: {
  },
  mounted () {
		apiClient.getUser({ 
			id: this.$route.params.id
		}).then(response => {
			console.log(response)
			this.user = response
		})
  },
}
</script>
